import React from 'react';
import { useParams } from "react-router-dom";
import ClubRow from '../components/ClubRow';
import ClubListButtons from '../components/ClubListButtons';
import Header from "../../Units/Header";
import "../../../assets/stylesheets/Union/UnionClubList.scss";
import {useSelector} from "react-redux";
import {getAccountAvatars, getUnionApprovedClubs} from "../../../store/selectors";

const ClubList = () => {
    const { id: unionId } = useParams();
    const clubList = useSelector(getUnionApprovedClubs);
    const avatarList = useSelector(getAccountAvatars);

    const renderButtons = data => (
        <ClubListButtons data={data} />
    );
    const renderRow = club => (
        <ClubRow key={club._id} data={club} avatar={avatarList[club._id]} renderActions={renderButtons} />
    );

    return (
        <div className="clubListPage unionPage">
            <Header title={'unionClubsTitle'} backTo={`/union/${unionId}`} className="dialogHeader--gray" />
            <ul className="clubList">
                {clubList.map(renderRow)}
            </ul>
        </div>
    );
};

export default ClubList;
